import { motion } from "framer-motion";

const testimonials = [
  {
    quote:
      "Ritesh didn't just rewrite our menu — he rewrote our margins. We recovered the audit fee in six weekends flat.",
    name: "Aditya",
  },
  {
    quote:
      "He watched two nights on the floor and spotted things our management team had lived with for a year. Uncomfortable, and exactly what we needed.",
    name: "Neha",
  },
  {
    quote:
      "For a pre-launch, this is the calmest, sharpest advisory we've worked with. The details compound — from hiring to the first-hour guest flow.",
    name: "Kabir",
  },
  {
    quote:
      "Our spend-per-cover moved up 22% in ninety days. No new marketing spend. Just the audit and a disciplined 90-day roadmap.",
    name: "Rohan",
  },
  {
    quote:
      "The pour-cost and staffing calls alone paid for the engagement inside a quarter. I'd hire him again for our second property tomorrow.",
    name: "Sanjana",
  },
  {
    quote:
      "He speaks the operator's language, not the consultant's. That's rare, and it's why the plan actually got implemented.",
    name: "Arjun",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-20 md:py-40 bg-[#030303]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-24">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
            Ch. 08 &mdash; Words from the room
          </div>
          <h2 className="font-display text-white text-[34px] sm:text-4xl md:text-6xl lg:text-[80px] leading-[0.98] tracking-[-0.02em] max-w-4xl">
            Quiet notes from{" "}
            <em className="font-editorial italic text-[#D4AF37] font-light">
              operators who ship.
            </em>
          </h2>
          <div className="mt-3 text-white/45 text-xs uppercase tracking-[0.24em]">
            *Client confidentiality &mdash; only first names shown
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative rounded-2xl border border-white/8 bg-white/[0.02] backdrop-blur-xl p-7 sm:p-8 md:p-10 min-h-[240px] md:min-h-[280px] flex flex-col justify-between"
            >
              <div className="font-editorial text-[#D4AF37]/70 text-6xl leading-none">
                &ldquo;
              </div>
              <blockquote className="font-editorial italic text-white text-lg md:text-[22px] leading-snug -mt-4">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10 text-sm">
                <div className="text-white">{t.name}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
